import { RequestInterceptor } from "utils/api-client/interceptors";
import { getCookie } from "utils/cookies";

export const requestSendCsrfToken: RequestInterceptor = async ({ request }) => {
  const token = getCookie("XSRF-TOKEN") as string;
  request.headers.append("X-XSRF-TOKEN", token);
  return request;
};
